<template>
  <b-container v-if="this.type">
    <h1 v-if="!staticItem" v-translate="{type: $appConfig.models[this.type].title}">Edit %{type}</h1>
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      <translate>The Item has been updated</translate>
    </b-alert>
    <div class="my-3" v-if="$appConfig.models[type].extraActions" >
      <hr>
      <span v-for="(action, index) in $appConfig.models[type].extraActions" :key="index">
        <b-button
          :size="action.size || 'sm'"
          :variant="action.variant || 'primary'"
          @click="action.action(item)"
          :title="action.title || ''"
          style="padding: .5rem .65rem"
          class="mb-1"
          :disabled="(action.disabledCondition && action.disabledCondition(item))"
        >
          <font-awesome-icon v-if="action.icon" :icon="action.icon" size="2x" style="font-size: 16px;vertical-align: middle" />
          <span v-if="action.label">{{action.label}}</span>
        </b-button>
      </span>
      <hr>
    </div>
    <b-form @submit.prevent="patchItem">
      <div
        :id="'fieldsetHorizontal' + index"
        v-for="(field, index) in fields"
        :key="index"
      >
        <b-form-row
          class="mb-3"
          v-if="field.type !== Array"
        >
          <b-col sm="4" lg="3">
            <label id="fieldsetHorizontal__BV_label_" :for="'inputHorizontal'+ index" class="col-form-label">{{field.label || snakeCaseToTitleCase(field.key)}}<small class="text-danger" v-if="field.required"> *</small></label>
          </b-col>
          <b-col>
            <component :id="'input-' + index" v-model="item[field.key]" v-if="field.componentEdit" :is="fields.find(x => x.key === field.key).componentEdit(item[field.key], field.key, item).is" v-b-tooltip.html v-bind="fields.find(x => x.key === field.key).componentEdit(item[field.key], field.key, item).props" v-on="fields.find(x => x.key === field.key).componentEdit(item[field.key], field.key, item).on"></component>
            <b-form-select v-else-if="field.type === Boolean" v-model="item[field.key]" :options="[{value: 1, text: $gettext('Yes')}, {value: 0, text: $gettext('No')}]" :disabled="!field.editable || (field.editCondition && !field.editCondition(item))">
              <template #first>
                <option :value="null" v-translate>Select</option>
              </template>
            </b-form-select>
            <b-form-select v-else-if="field.type === 'select' && initialized && !field.showRaw" v-model="item[field.key]" :options="setFieldOptions(field.options, field.withSelect)" :disabled="!field.editable || (field.editCondition && !field.editCondition(item))">
              <template #first>
                <option :value="null" v-translate>Select</option>
              </template>
            </b-form-select>
            <b-form-select v-else-if="field.type === 'select' && initialized && !field.editable && field.showRaw" v-model="item[field.key]" :options="[item[field.key]]" :disabled="!field.editable"></b-form-select>
            <b-row v-else-if="field.type === 'datetime' && item[field.key + 'DateTimeParts']">
              <b-col><b-form-input type="date" v-model="item[field.key + 'DateTimeParts'][0]"></b-form-input></b-col>
              <b-col><b-form-input type="time" v-model="item[field.key + 'DateTimeParts'][1]"></b-form-input></b-col>
            </b-row>
            <b-form-timepicker v-else-if="field.type === 'time'" v-model="item[field.key]" :required="field.required" :disabled="!field.editable || (field.editCondition && !field.editCondition(item))"></b-form-timepicker>
            <v-jsoneditor :height="'500px'" v-model="item[field.key]" v-else-if="field.type === 'JSON'" :key="'json-' + index" :options="{modes: ['tree', 'view', 'form', 'code', 'text', 'preview'], mode: 'code'}"></v-jsoneditor>
            <span v-else-if="field.type === 'link'"><a :href="item[field.key]" target="_blank">{{item[field.key]}}</a></span>
            <b-form-textarea v-else-if="field.type === 'textarea'" :id="'inputHorizontal'+ index" v-model="item[field.key]" :required="field.required" />
            <b-form-input v-else-if="field.type !== Boolean" :id="'inputHorizontal'+ index" :type="field.type === 'integer' ? 'number' : (field.type || 'text')" :step="field.type === 'integer' ? 1 : (field.step || null)" v-model="item[field.key]" :required="field.required" :disabled="!field.editable || (field.editCondition && !field.editCondition(item))" />
            <b-form-input v-else-if="field.type === 'integer'" :id="'inputHorizontal'+ index" type="number" :step="1" v-model="item[field.key]" :disabled="!field.editable || (field.editCondition && !field.editCondition(item))" :required="field.required" />
            <b-form-input :id="'inputHorizontal'+ index" :type="field.type || 'text'" :step="field.type === 'time' && field.step ? field.step : null" v-model="item[field.key]" :disabled="!field.editable || (field.editCondition && !field.editCondition(item))" :required="field.required" v-else />
            <small tabindex="-1" class="form-text text-muted" v-if="field.description" v-html="field.description"></small>
          </b-col>
        </b-form-row>
        <b-form-row v-else>
          <label id="fieldsetHorizontal__BV_label_" :for="'inputHorizontal'+ index" class="col-form-label" v-if="item[field.key]">{{field.label || snakeCaseToTitleCase(field.key)}}<small class="text-danger" v-if="field.required"> *</small></label>
           <b-form-input v-for="(subitem, i) in item[field.key]" v-model="item[field.key][i]" :key="i" class="mb-3"></b-form-input>
        </b-form-row>
      </div>
      <b-form-row >
        <b-col cols="12" class="my-3">
          <hr>
        </b-col>
        <b-col>
          <b-button type="submit" variant="primary" v-translate>Submit</b-button>
        </b-col>
        <!-- HACK -->
        <b-col v-if="type === 'item-packs' && item.status === 'DRAFT' && (!item.serial_numbers || item.serial_numbers.length === 0)" class="text-center">
          <b-button type="button" variant="warning" v-b-modal.modalPistolScan v-translate>Pistol Scan!</b-button>
          <b-modal id="modalPistolScan" ref="modalPistolScan" title="Start scanning" hide-footer @shown="$refs.packItemsTexarea.focus()" @hide="packItems = ''">
            <form @submit.stop.prevent="submitPackItems">
              <p :class="(packItems.match(/\n/g) || []).length !== item.quantity ? 'text-danger' : 'text-success'">
                <span v-translate="{qty: item.quantity}">Expected Items: <strong>%{qty}</strong></span><br>
                <span v-translate="{qty: (packItems.match(/\n/g) || []).length}">Currently Scanned Items: <strong>%{qty}</strong></span>
              </p>
              <b-form-textarea
                ref="packItemsTexarea"
                v-model="packItems"
                :placeholder="$gettext('Start scanning...')"
                :state="(packItems.match(/\n/g) || []).length === item.quantity"
                rows="10"
                :max-rows="item.quantity"
              ></b-form-textarea>
              <b-form-row>
                <b-col cols="12" class="my-3">
                  <hr>
                </b-col>
                <b-col>
                  <b-button type="submit" variant="primary" :disabled="(packItems.match(/\n/g) || []).length !== item.quantity" v-translate>Submit</b-button>
                </b-col>
                <b-col class="text-right" v-if="this.$appConfig.models[this.type].allowDelete">
                  <b-button @click.stop="$refs.modalPistolScan.hide()" variant="danger" v-translate>Cancel</b-button>
                </b-col>
              </b-form-row>
            </form>
          </b-modal>
        </b-col>
        <!-- /HACK -->
        <b-col class="text-right" v-if="this.$appConfig.models[this.type].allowDelete">
          <b-button @click.stop="deleteItem" variant="danger" v-translate>DELETE Item</b-button>
        </b-col>
      </b-form-row>
    </b-form>
  </b-container>
</template>
<script>
import VJsoneditor from 'v-jsoneditor/src/index'

export default {
  name: 'ApiItemEdit',
  components: {
    VJsoneditor,
    ApiList: () => import('@/components/ApiList'), // hack for recursive component problem with name
    FleetRentalOrderForm: () => import('@/components/FleetRentalOrderForm')
  },
  props: {
    type: {
      type: String,
      required: true
    },
    id: {
      type: [Number, String],
      required: false
    },
    staticItem: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      initialized: false,
      fields: this.$appConfig.models[this.type].fields,
      item: {},
      success: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      // HACK
      packItems: ''
    }
  },
  watch: {
    type: function (val) {
      this.fields = this.$appConfig.models[this.type].fields
    }
  },
  mounted() {
    if (!this.staticItem) {
      this.getItem()
    } else {
      this.item = this.staticItem.item
    }
    this.init()
  },
  methods: {
    async init() {
      for (let field of this.fields) {
        if (field.options && !Array.isArray(field.options)) {
          await this['fetch' + field.options.charAt(0).toUpperCase() + field.options.slice(1)]()
        }
      }
      this.initialized = true
    },
    getItem() {
      let params = {}
      if (this.$appConfig.models[this.type].includes) {
        params.includes = this.$appConfig.models[this.type].includes
      }
      this.$http.get(this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint + '/' + this.id, {params: params})
        .then(response => {
          this.item = response.body
          for (let field of this.fields) {
            if (field.type === 'datetime') {
              if (this.$appConfig.models[this.type].countrize || this.$appConfig.models[this.type].countrizeById) {
                this.$tz = window.countries.find(x => x.iso_code === this.item[this.$appConfig.models[this.type].countrize] || x.id === this.item[this.$appConfig.models[this.type].countrizeById]).front_config.i18n.tz
                this.moment.tz.setDefault(this.$tz)
                const watchCountryKey = 'item.' + (this.$appConfig.models[this.type].countrize || this.$appConfig.models[this.type].countrizeById)
                this.$watch(
                  watchCountryKey,
                  (val) => {
                    this.$tz = window.countries.find(x => x.iso_code === val || x.id === val).front_config.i18n.tz
                    this.moment.tz.setDefault(this.$tz)
                  },
                  {
                    immediate: true
                  }
                )
              }
              this.item[field.key + 'DateTimeParts'] = []
              this.item[field.key + 'DateTimeParts'][0] = this.moment.utc(this.item[field.key]).tz(this.$tz).format('YYYY-MM-DD')
              this.item[field.key + 'DateTimeParts'][1] = this.moment.utc(this.item[field.key]).tz(this.$tz).format('HH:mm:ss')
            }
          }
        })
    },
    patchItem() {
      let toPatch = {}
      for (let field in this.fields) {
        if (this.fields[field].editable) {
          toPatch[this.fields[field].key] = this.item[this.fields[field].key]
        }
        if (this.fields[field].editable && this.fields[field].toLowerCase) {
          toPatch[this.fields[field].key] = toPatch[this.fields[field].key].toLowerCase()
        }
        if (this.fields[field].type === 'time' && !this.fields[field].withSeconds && this.item[this.fields[field].key].split(':').length === 3) {
          const timeParts = this.item[this.fields[field].key].split(':')
          toPatch[this.fields[field].key] = `${timeParts[0]}:${timeParts[1]}`
        }
        if (this.fields[field].type === 'datetime') {
          if (this.item[this.fields[field].key + 'DateTimeParts'].length > 0) {
            toPatch[this.fields[field].key] = this.moment.tz(this.item[this.fields[field].key + 'DateTimeParts'].join(' '), this.$tz).utc().format('YYYY-MM-DD HH:mm:ss')
          } else {
            toPatch[this.fields[field].key] = null
          }
        }
      }

      this.$http.patch(this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint + '/' + this.id, toPatch)
        .then(response => {
          this.showAlert()
          if (!this.staticItem) {
            this.getItem()
          } else {
            this.$emit('success', this.staticItem)
          }
        })
    },
    deleteItem() {
      if (
        confirm(this.$gettextInterpolate(this.$gettext('Are you sure you want to DELETE the row with ID:\n%{id}\nWARNING: THIS ACTION CANNOT BE UNDONE!'), {id: this.id}))
      ) {
        let endpoint = this.$appConfig.models[this.type].endpointDelete ? this.$appConfig.models[this.type].endpointDelete.replace('{id}', this.id) : this.$appConfig.models[this.type].endpoint + '/' + this.id
        this.$http.delete(this.$appConfig.api.baseUrl + endpoint)
          .then(response => {
            this.$router.push('/list/' + this.$appConfig.models[this.type].endpoint, { query: { deleted: true } })
          })
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    // HACK
    submitPackItems() {
      let serialNumbers = this.packItems.split('\n').filter(Boolean)
      let dupes = this.checkDuplicates(serialNumbers)
      if (dupes) {
        let mssg = this.$gettextInterpolate(this.$gettext('<p>You have scanned DUPLICATED items. Please, REVIEW the serial numbers carefully: </p><ul class="text-left">%{dupes}</ul>'), {dupes: dupes})
        let obj = {
          title: this.$gettext('ERROR'),
          message: mssg,
          type: 'error'
        }
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
      } else {
        let payload = {
          serial_numbers: serialNumbers
        }
        this.$http.patch(this.$appConfig.api.baseUrl + 'item-packs/' + this.item.id, payload)
          .then(response => {
            this.$refs.modalPistolScan.hide()
            this.getItem()
          })
      }
    },
    checkDuplicates(array) {
      let counts = {}
      let mssg = ''

      for (const item of array) {
        if (counts[item]) {
          counts[item] += 1
        } else {
          counts[item] = 1
        }
      }
      for (let prop in counts) {
        if (counts[prop] >= 2) {
          mssg += this.$gettextInterpolate(this.$gettext('<li>%{prop}: %{qty} times</li>'), {prop: prop, qty: counts[prop]})
        }
      }
      if (mssg) {
        return mssg
      } else {
        return false
      }
    },
    setFieldOptions(fetch, options = false) {
      if (!Array.isArray(fetch)) {
        if (fetch === 'shippingStatusReasons') {
          return Object.entries(this.shippingStatusReasons).reduce((a, [key, value], i) => (
            a.concat(value.map(y => {
              return {
                text: key + ' - ' + y.name,
                value: y.reason_id
              }
            }))
          ), [])
        } else {
          if (!options) {
            return this[fetch]
          } else {
            return this[fetch + 'Select']
          }
        }
      } else {
        return fetch
      }
    }
  }
}
</script>
